import Head from 'next/head'
import React from 'react'

type InterviewHeadProps = {
  company: string
  interviewer: string
  ogUrl: string
}

const InterviewHead: React.FC<InterviewHeadProps> = ({ company, ogUrl, interviewer }) => {
  return (
    <Head>
      <title>{`【お客様の声】${company}様：アット葬儀（@葬儀）｜オンライン葬儀`}</title>
      <meta
        name="description"
        content={`オンライン葬儀サービス「アット葬儀（@葬儀）」について、${company} ${interviewer}様に＠葬儀導入の経緯や、実際に使ってみての感想や喪主様の意見、また今後の展開などについてお伺いいたしました。`}
      />

      {/* OGP設定 */}
      <meta property="og:url" content={ogUrl} />
      <meta property="og:type" content="article" />
      <meta
        property="og:title"
        content={`【お客様の声】${company}様：アット葬儀（@葬儀）｜オンライン葬儀`}
      />
      <meta
        property="og:description"
        content={`オンライン葬儀サービス「アット葬儀（@葬儀）」について、${company} ${interviewer}様に＠葬儀導入の経緯や、実際に使ってみての感想や喪主様の意見、また今後の展開などについてお伺いいたしました。`}
      />
      <meta property="og:site_name" content="アット葬儀（@葬儀）" />
      <meta
        property="og:image"
        content={`${process.env.NEXT_PUBLIC_PUBLIC_SITE_ORIGIN}/images/ogp_atsougi.png`}
      />

      {/* Twitter設定 */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content={`【お客様の声】${company}様：アット葬儀（@葬儀）｜オンライン葬儀`}
      />
      <meta name="twitter:site" content={ogUrl} />
      <meta
        name="twitter:image"
        content={`${process.env.NEXT_PUBLIC_PUBLIC_SITE_ORIGIN}/images/ogp_atsougi.png`}
      />
      <meta
        name="twitter:description"
        content={`オンライン葬儀サービス「アット葬儀（@葬儀）」について、${company} ${interviewer}様に＠葬儀導入の経緯や、実際に使ってみての感想や喪主様の意見、また今後の展開などについてお伺いいたしました。`}
      />
    </Head>
  )
}

export default InterviewHead
